import React, { useEffect, useState } from 'react';
import map from 'lodash/map';
import max from 'lodash/max';
import uniq from 'lodash/uniq';

import { getPaymentVendorInterestFreeList } from '../../graphql/payment-vendor-interest-free-list.2';
import { InterestFreeView } from './InterestFreeView';

export interface PaymentProps {
  financial_company_code: string;
  installment_month_list: number[];
  min_amount: number;
}

export const InterestFree = () => {
  const [financialCompanyList, setFinancialCompanyList] = useState<PaymentProps[]>([]);
  useEffect(() => {
    const reqFinancialCompanyList = async () => {
      const {
        data: { payment_vendor_interest_free_list },
      } = await getPaymentVendorInterestFreeList();

      const financial_company_code_list = uniq(
        map(payment_vendor_interest_free_list.item_list, (o) => o.financial_company_code),
      );

      const effective_list: PaymentProps[] = financial_company_code_list.map((code) => {
        const list = payment_vendor_interest_free_list.item_list.filter((o) => o.financial_company_code === code);
        const min_amount = max(map(list, (o) => o.min_amount)) ?? 0;
        const installment_month_list = uniq(map(list, (o) => o.installment_month));

        return {
          financial_company_code: code,
          installment_month_list,
          min_amount,
        };
      });

      setFinancialCompanyList(effective_list);
    };
    reqFinancialCompanyList();
  }, []);

  return <InterestFreeView financialCompanyList={financialCompanyList} />;
};
